import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Icon from '../Icon'
import routes from '../../config/routes'

const BackButton = ({ classes }) => {
  return (
    <Link
      to={routes.root}
      data-element="go-back"
      className={classes.backButton}
    >
      <Icon name="arrowLeft" />
      <span className={classes.backButtonLabel}>Back</span>
    </Link>
  )
}

BackButton.propTypes = {
  classes: PropTypes.shape({
    backButton: PropTypes.string,
    backButtonLabel: PropTypes.string,
  }),
}

export default BackButton
